var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-effect",on:{"click":function($event){return _vm.$emit('clickButton')}}},[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }